import { Person } from 'models';

export class Accommodation {
	accommodationId: number;
	friendlyName: string;
	addressLine1: string;
	addressLine2: string;
	town: string;
	countryId: number;
	postcode: string;
	numberOfBedrooms: number;
	numberOfBathrooms: number;
	integrationId: string;
	isActive: boolean;
	paymentValidationSetId: number;

	constructor(props: { [key in keyof Accommodation]?: Accommodation[key] }) {
		Object.assign(this, {
			...props,
		});
	}
}

export class AccommodationCreate {
	accommodation: Accommodation;
	hostDetails: Person;
}

export interface IAccommodationSearchResult {
	accommodationId: number;
	friendlyName: string;
	addressLine1: string;
	addressLine2: string;
	town: string;
	postcode: string;

	hostFirstName: string;
	hostLastName: string;
	hostAvatar: string;
}

export class AccommodationPhotoUpload {
	accommodationId: number;
	imageType: AccommodationImageType;
}

export enum AccommodationImageType {
	Avatar = 1,
	Cover = 2,
	Other = 3,
}

export class AccommodationPublicProfile {
	friendlyName: string;
	location: string;
	hostName: string;
	email: string;
	telephone: string;
	managed: boolean;
	createdDate: Date;
}

export interface HTMLInputEvent extends Event {
	target: HTMLInputElement & EventTarget;
}
